import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults as ProviderSearchResult } from '@/__generated__/seoSegmentationListingPage';

export const hasPhilosophiesOrSchoolTypes = (
  philosophies: ProviderSearchResult['philosophies'],
  schoolTypes: ProviderSearchResult['schoolTypes']
) => {
  const hasValidProperties = (
    obj: ProviderSearchResult['philosophies'] | ProviderSearchResult['schoolTypes']
  ): boolean =>
    obj != null &&
    typeof obj === 'object' &&
    Object.entries(obj)
      .filter(([key]) => key !== '__typename')
      .some(([, value]) => Boolean(value));

  const hasPhilosophies = hasValidProperties(philosophies);
  const hasSchoolTypes = hasValidProperties(schoolTypes);

  return hasPhilosophies || hasSchoolTypes;
};
